import { ComboItem, MultiLangDto, Response } from "../../../../model";
import { DiccionarioListOut } from "../../../../model/comunicacion/DiccionarioListOut";
import { DiccionarioUpdatesOut } from "../../../../model/comunicacion/DiccionarioUpdatesOut";
import { NotificacionDeleteIn } from "../../../../model/comunicacion/NotificacionDeleteIn";
import { NotificacionIn } from "../../../../model/comunicacion/NotificacionIn";
import { NotificacionMarkreadIn } from "../../../../model/comunicacion/NotificacionMarkreadIn";
import { NotificacionNewsOut } from "../../../../model/comunicacion/NotificacionNewsOut";
import { InstructivoEditIn, InstructivoEditOut } from "../../../../model/comunicacion/InstructivoEditOut";
import { InstructivoListOut } from "../../../../model/comunicacion/InstructivoListOut";
import ServiceBase from "../../../servicebase";
import { ControllerEntityService } from "./ControllerEntityService";

export class ComunicacionService extends ServiceBase {
  private controller: string = 'Comunicacion';

  Diccionario = () => new DiccionarioService(this.urlAPI, this.controller);

  Notificaciones = () => new NotificacionService(this.urlAPI, this.controller);
  Instructivo = () => new ControllerEntityService<InstructivoEditOut, InstructivoEditIn, InstructivoListOut, ComboItem, { titulo?: string, tags?: string }, {}>(this.urlAPI, this.controller, "Instructivo");
}

export class DiccionarioService extends ControllerEntityService<MultiLangDto, MultiLangDto, DiccionarioListOut, ComboItem, { key?: string, valueES?: string, valueEN?: string }, {}> {
  constructor(urlApi: string, controller: string) {
    super(urlApi, controller, "Diccionario");
  }
    
  updates = (data: { idIdioma?: number, from?: string }) => 
    this.GetFetch<Response<DiccionarioUpdatesOut>>(`${this._controller}/${this._entity}/updates/v2`, { ...data, origen: 'BO' });
  
}


export class NotificacionService extends ServiceBase {
  _controller: string = '';
  _entity: string = 'notificacion';

  constructor(api: string, controller: string) {
    super(api);
    this._controller = controller;
  }
  
  news = (data: { }) => 
    this.GetFetch<Response<NotificacionNewsOut[]>>(`${this._controller}/${this._entity}/news`, data);
  
  send = (data:NotificacionIn) => 
    this.PostFetch<Response<void>>(`${this._controller}/${this._entity}/send`, data);

  markread = (data:NotificacionMarkreadIn) => 
    this.PostFetch<Response<void>>(`${this._controller}/${this._entity}/markread`, data);

  remove = (data:NotificacionDeleteIn) => 
    this.PostFetch<Response<void>>(`${this._controller}/${this._entity}/remove`, data);
}